import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useEffect, useState, useContext } from "react";
import {
  addDoc,
  collection,
  serverTimestamp,
  getDocs,
  where,
  query,
  updateDoc,
  arrayUnion,
  doc
} from "firebase/firestore";
import { db, storage } from "../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { uploadLogToFirestore, uploadErrorLogToFirestore } from "../../utils/logUtils";
import { fetchAdministrativosAsignados, fetchInspectoresAsignados } from "./utils/FirebaseUtils";
import { useSidebarState } from "../../components/sidebar/SidebarStateContext";
import { comunidades, provincias } from "../../zoneData";
import noImage from '../../images/no-image.png';
import EmpresaComponent from './utils/EmpresaComponent'; // Importamos el componente de empresa
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';


/**
 * Componente para crear una nueva cliente.
 *
 * @param {Object} inputs - Los campos de entrada para la cliente.
 * @param {string} title - El título del formulario.
 * @returns {JSX.Element} - Componente Newcliente.
 */
const NewCliente = ({ inputs, title }) => {
  const { currentUser, currentService, adminData } = useContext(AuthContext);
  const [file, setFile] = useState("");
  const [data, setData] = useState({});
  const [per, setPerc] = useState(null);
  const [inspectoresAsignados, setInspectoresAsignados] = useState([]);
  const [administrativosAsignados, setAdministrativosAsignados] = useState([]);
  const [selectedInspectores, setSelectedInspectores] = useState([]);
  const [selectedAdministrativos, setSelectedAdministrativos] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [adminProvincias, setAdminProvincias] = useState(adminData?.provincias || []);
  const [adminComunidades, setAdminComunidades] = useState(adminData?.comunidades || []);
  const [contacts, setContacts] = useState([{ nombre: '', email: '' }]);
  const [selectedEmpresa, setSelectedEmpresa] = useState(''); // Estado para la empresa seleccionada
  const [availableForms, setAvailableForms] = useState([]); // Formularios disponibles
  const [selectedForms, setSelectedForms] = useState([]); // Formularios seleccionados para el cliente

  const navigate = useNavigate();
  const { collapsed } = useSidebarState();
  const containerClass = collapsed ? "newContainer collapsed" : "newContainer";

  useEffect(() => {
    // Comprobar si currentService está disponible
    if (currentService) {
      console.log('CurrentService cargado:', currentService);
      const currentServiceId = currentService.id;

      // Obtener inspectores asignados
      fetchInspectoresAsignados(currentServiceId).then((inspectores) => {
        setInspectoresAsignados(inspectores);
      });

      // Obtener administrativos asignados
      fetchAdministrativosAsignados(currentServiceId).then((administrativos) => {
        setAdministrativosAsignados(administrativos);
      });

      // Cargar formularios disponibles
      fetchAvailableForms(currentServiceId);
    } else {
      console.log('CurrentService no está disponible aún');
    }
  }, [currentService]);

  // Función para cargar formularios disponibles
  const fetchAvailableForms = async (serviceId) => {
    try {
      console.log('Cargando formularios para el servicio:', serviceId);
      const formsRef = collection(db, 'servicios', serviceId, 'forms');
      const formsSnapshot = await getDocs(formsRef);
      
      const forms = formsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      console.log('Formularios encontrados:', forms);
      setAvailableForms(forms);
    } catch (error) {
      console.error('Error al cargar formularios:', error);
    }
  };

  useEffect(() => {
    const uploadFile = () => {
      const name = new Date().getTime() + file.name;

      const storageRef = ref(storage, file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          setPerc(progress);
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
            default:
              break;
          }
        },
        (error) => {
          console.log(error);
          uploadErrorLogToFirestore(error)

        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setData((prev) => ({ ...prev, img: downloadURL }));
          });
        }
      );
    };
    file && uploadFile();
  }, [file]);


  const handleContactChange = (index, field, value) => {
    const newContacts = [...contacts];
    newContacts[index][field] = value;
    setContacts(newContacts);
    setData({ ...data, contacts: newContacts });
  };

  const addContact = () => {
    setContacts([...contacts, { nombre: '', email: '' }]);
  };

  const removeContact = (index) => {
    const newContacts = contacts.filter((_, i) => i !== index);
    setContacts(newContacts);
    setData({ ...data, contacts: newContacts });
  };

  // Manejador para cuando cambia la empresa seleccionada
  const handleEmpresaChange = (empresaData) => {
    setData(prev => ({
      ...prev,
      empresaId: empresaData.empresaId,
      empresaNombre: empresaData.empresaNombre,
      codEmpresa: empresaData.codEmpresa
    }));
  };

  // Manejador para la selección de formularios
  const handleFormsChange = (event) => {
    const value = event.target.value;
    setSelectedForms(value);
  };

  /**
* Maneja el cambio de los campos de entrada.
*
* @param {Object} e - Evento del campo de entrada.
*/
  const handleInput = (e) => {
    const id = e.target.id || e.target.name;
    const isSelectMultiple = Array.isArray(e.target.value);
    const value = isSelectMultiple ? e.target.value : e.target.value;

    if (id === "inspectoresAsignados") {
      setSelectedInspectores(value);
    } else if (id === "administrativosAsignados") {
      setSelectedAdministrativos(value);
    } else {
      setData({ ...data, [id]: value });
    }
  };

  /**
 * Maneja el registro de la nueva cliente.
 *
 * @param {Object} e - Evento del formulario.
 */
  const handleAdd = async (e) => {
    e.preventDefault();

    // Verificar que se ha seleccionado una empresa
    if (!data.empresaId) {
      alert("Debe seleccionar una empresa");
      return;
    }

    try {
      const serviciosRef = collection(db, "servicios");
      const q = query(
        serviciosRef,
        where("admins", "array-contains", currentUser.email)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const servicioDoc = querySnapshot.docs[0];
        const clientesRef = collection(servicioDoc.ref, "clientes");

        // Check if the client with the same name already exists
        const existingClients = await getDocs(
          query(clientesRef, where("nombre", "==", data.nombre))
        );

        if (!existingClients.empty) {
          alert(
            "El cliente con este nombre ya ha sido registrado. Por favor, elige otro nombre."
          );

          console.log("Client with the same name already exists!");
          uploadErrorLogToFirestore("Client with the same name already exists!");
          return;
        }

        // If the client with the same name doesn't exist, proceed with adding the new client
        const newClientRef = await addDoc(clientesRef, {
          ...data,
          timeStamp: serverTimestamp(),
          inspectoresAsignados: selectedInspectores, // Agrega inspectores asignados
          administrativosAsignados: selectedAdministrativos, // Agrega administrativos asignados
        });

        // Get the ID assigned to the new client document
        const newClientId = newClientRef.id;

        // Update the document with the assigned ID
        await updateDoc(newClientRef, { id: newClientId });

        // Update admins collection for each assigned inspector
        for (const inspectorId of selectedInspectores) {
          const inspectorRef = doc(db, 'servicios', currentService.id, 'admins', inspectorId);
          await updateDoc(inspectorRef, {
            clientes: arrayUnion(newClientId),
          });
        }

        // Update admins collection for each assigned administrativo
        for (const administrativoId of selectedAdministrativos) {
          const administrativoRef = doc(db, 'servicios', currentService.id, 'admins', administrativoId);
          await updateDoc(administrativoRef, {
            clientes: arrayUnion(newClientId),
          });
        }

        // Update forms collection to include the new client in their assigned clients array
        for (const formId of selectedForms) {
          const formRef = doc(db, 'servicios', currentService.id, 'forms', formId);
          await updateDoc(formRef, {
            cliente: arrayUnion(newClientId),
          });
        }

        uploadLogToFirestore("cliente añadido");

        navigate("/clientes");

        // Forzar la recarga de la página
        window.location.reload();
        navigate("/clientes");

      }
    } catch (err) {
      console.log(err);
    }
  };

  const getInspectorNameById = (id) => {
    const inspector = inspectoresAsignados.find(ins => ins.id === id);
    return inspector ? inspector.apellido ? `${inspector.nombre} ${inspector.apellido}` : inspector.nombre : '';
  };

  const getAdministrativoNameById = (id) => {
    const administrativo = administrativosAsignados.find(adm => adm.id === id);
    return administrativo ? administrativo.apellido ? `${administrativo.nombre} ${administrativo.apellido}` : administrativo.nombre : '';
  };

  return (
    <div className="new">
      <Sidebar />
      <div className={containerClass}>
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => navigate(-1)}
            style={{ marginLeft: '20px' }}
          >
            Volver
          </Button>
        </div>
        <div className="bottom">
          <div className="left">
            <img
              src={file ? URL.createObjectURL(file) : noImage}
              alt=""
            />
            <label htmlFor="file">
              <div className='upload-label'>
                <DriveFolderUploadOutlinedIcon className="icon" /> Subir imagen
              </div>
            </label>
          </div>
          <div className="right">
            <form onSubmit={handleAdd}>
              <div className="formInput">
                <input
                  type="file"
                  id="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  style={{ display: "none" }}
                />
              </div>
              
              {/* Componente selector de empresa */}
              <div className="formInput" style={{ marginBottom: '20px' }}>
                <EmpresaComponent
                  selectedEmpresa={selectedEmpresa}
                  setSelectedEmpresa={setSelectedEmpresa}
                  onEmpresaChange={handleEmpresaChange}
                />
              </div>
              
              <div className="inputPairs">
                {inputs.map((input) => (
                  <div className="formInput" key={input.id}>
                    <label>{input.label}</label>
                    {input.id === "inspectoresAsignados" && (
                      <FormControl sx={{ m: 1, width: 300 }}>
                        <InputLabel id="inspectoresAsignados-label">{input.label}</InputLabel>
                        <Select
                          id={input.id}
                          name="inspectoresAsignados"
                          multiple
                          value={selectedInspectores}
                          onChange={(e) => handleInput(e)}
                          input={<OutlinedInput id="select-inspectores" label="Inspectores" />}
                          renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {selected.map((id) => (
                                <Chip key={id} label={getInspectorNameById(id)} />
                              ))}
                            </Box>
                          )}
                        >
                          {inspectoresAsignados.map((inspector) => (
                            <MenuItem key={inspector.id} value={inspector.id}>
                              {inspector.nombre} {inspector.apellido}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                    {input.id === "administrativosAsignados" && (
                      <FormControl sx={{ m: 1, width: 300 }}>
                        <InputLabel id="administrativosAsignados-label">{input.label}</InputLabel>
                        <Select
                          id={input.id}
                          name="administrativosAsignados"
                          multiple
                          value={selectedAdministrativos}
                          onChange={(e) => handleInput(e)}
                          input={<OutlinedInput id="select-administrativos" label="Administrativos" />}
                          renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {selected.map((id) => (
                                <Chip key={id} label={getAdministrativoNameById(id)} />
                              ))}
                            </Box>
                          )}
                        >
                          {administrativosAsignados.map((administrativo) => (
                            <MenuItem key={administrativo.id} value={administrativo.id}>
                              {administrativo.nombre} {administrativo.apellido}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                    {(input.type === "dropdown" && input.id !== "administrativosAsignados" && input.id !== "inspectoresAsignados") && ( // Verifica si el tipo es "dropdown"
                      <FormControl sx={{ m: 1, width: 300 }}>
                        <InputLabel id={`${input.id}-label`}>{input.label}</InputLabel>
                        <Select
                          id={input.id}
                          name={input.id}
                          value={selectedValues[input.id] || ""}
                          onChange={(e) => handleInput(e)}
                          input={<OutlinedInput id={`select-${input.id}`} label={input.label} />}
                        >
                          {/* Renderiza las opciones específicas para "comunidad" y "provincia" solo si es dropdown */}
                          {(input.id === "comunidad" && input.type === "dropdown") ? (
                            adminComunidades && adminComunidades.map((comunidad) => (
                              <MenuItem key={comunidad} value={comunidad}>
                                {comunidad}
                              </MenuItem>
                            ))
                          ) : (input.id === "provincia" && input.type === "dropdown") ? (
                            adminProvincias && adminProvincias.map((provincia) => (
                              <MenuItem key={provincia} value={provincia}>
                                {provincia}
                              </MenuItem>
                            ))
                          ) : null}
                        </Select>
                      </FormControl>
                    )}
                    {(input.type !== "dropdown") && ( // Renderiza el input de texto solo si no es dropdown
                      <input
                        id={input.id}
                        type={input.type}
                        placeholder={input.placeholder}
                        onChange={handleInput}
                      />
                    )}

                  </div>
                ))}
                <div className="formInput contacts-section" style={{ width: '100%' }}>
                  <label>Contactos Cliente</label>
                  {contacts.map((contact, index) => (
                    <div key={index} className="contact-row" style={{
                      display: 'flex',
                      gap: '10px',
                      marginBottom: '10px',
                      alignItems: 'center'
                    }}>
                      <input
                        type="text"
                        placeholder="Nombre"
                        value={contact.nombre}
                        onChange={(e) => handleContactChange(index, 'nombre', e.target.value)}
                        style={{ flex: 1 }}
                      />
                      <input
                        type="email"
                        placeholder="Email"
                        value={contact.email}
                        onChange={(e) => handleContactChange(index, 'email', e.target.value)}
                        style={{ flex: 1 }}
                      />
                      <IconButton
                        onClick={() => removeContact(index)}
                        size="small"
                        style={{ visibility: contacts.length > 1 ? 'visible' : 'hidden' }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </div>
                  ))}
                  <Button
                    startIcon={<AddIcon />}
                    onClick={addContact}
                    variant="outlined"
                    size="small"
                    style={{ marginTop: '10px' }}
                  >
                    Añadir Contacto
                  </Button>
                </div>

                {/* Sección de formularios asignados */}
                <div className="formInput" style={{ 
                  width: '100%', 
                  marginTop: '20px',
                  padding: '15px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  backgroundColor: '#f9f9f9'
                }}>
                  <label style={{ 
                    fontWeight: 'bold', 
                    fontSize: '16px', 
                    marginBottom: '10px',
                    display: 'block',
                    color: '#333'
                  }}>
                    Formularios Asignados
                  </label>
                  
                  <div style={{ marginBottom: '10px' }}>
                    <p style={{ color: '#666', fontSize: '14px', marginBottom: '10px' }}>
                      Selecciona los formularios que estarán disponibles para este cliente:
                    </p>
                  </div>

                  <FormControl sx={{ m: 1, width: '100%', maxWidth: '400px' }}>
                    <InputLabel id="formularios-label">Seleccionar formularios</InputLabel>
                    <Select
                      id="formulariosAsignados"
                      name="formulariosAsignados"
                      multiple
                      value={selectedForms}
                      onChange={handleFormsChange}
                      input={<OutlinedInput id="select-formularios" label="Formularios" />}
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {selected.map((formId) => {
                            const form = availableForms.find(f => f.id === formId);
                            return (
                              <Chip 
                                key={formId} 
                                label={form ? form.name : formId}
                                style={{ backgroundColor: '#e3f2fd' }}
                              />
                            );
                          })}
                        </Box>
                      )}
                    >
                      {availableForms.map((form) => (
                        <MenuItem key={form.id} value={form.id}>
                          {form.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  
                  {availableForms.length === 0 && (
                    <div style={{ 
                      padding: '15px', 
                      backgroundColor: '#fff3cd', 
                      border: '1px solid #ffeaa7',
                      borderRadius: '5px',
                      marginTop: '10px'
                    }}>
                      <p style={{ color: '#856404', fontSize: '14px', margin: 0 }}>
                        No hay formularios disponibles. Crea formularios en la sección "Formularios" primero.
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="button-container">
                <button disabled={per !== null && per < 100} type="submit">
                  Registrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewCliente;